/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { connect } from 'react-redux' // Npm: React Redux for state management.
import { HiBuildingStorefront, HiPencil, HiTrash } from 'react-icons/hi2' // Npm: React icons library.
import { MdAlternateEmail } from 'react-icons/md' // Npm: React icons library.
import {
  IconButton,
  Menu,
  MenuItem
} from '@mui/material' // Npm: Material UI components.


/*
 * OBJECTS
 */
const Index = ({
  smppId,
  vendorAccountId,
  onVendorAccountUpdate,
  onVendorAccountDelete,
  onAutoRateImport,
  onAddSenderID,
  PassOnUpdate
}) => {
  // Hook assignment.
  const [_anchorEl, _setAnchorEl] = React.useState(null)
  const _open = Boolean(_anchorEl)

  const _handleClick = (event) => {
    _setAnchorEl(event.currentTarget)
  }

  const _handleClose = () => {
    _setAnchorEl(null)
  }

  // Return component.
  return (
    <>
      <IconButton
        onClick={_handleClick}
        sx={{
          margin: 'auto',
          borderRadius: '8px',
          color: 'gray.500',
          backgroundColor: 'transparent'
        }}>
        <HiPencil size={18} />
      </IconButton>
      <Menu
        anchorEl={_anchorEl}
        open={_open}
        onClose={_handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem
          onClick={() => {
            // Push vendor id to url.
            PassOnUpdate({ smppId, vendorAccountId })

            // Execute handler.
            onVendorAccountUpdate()

            _handleClose()
          }}
          sx={{
            gap: '12px',
            display: 'flex',
            pl: '20px',
            pr: '20px',
            color: 'gray.500',
            minHeight: '40px'
          }}>
          <HiPencil size={18} />
          <span>Edit Vendor Account</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            // Push vendor id to url.
            PassOnUpdate({ smppId, vendorAccountId })

            // Execute handler.
            onAddSenderID()

            _handleClose()
          }}
          sx={{
            gap: '12px',
            display: 'flex',
            pl: '20px',
            pr: '20px',
            color: 'gray.500',
            minHeight: '40px'
          }}>
          <HiBuildingStorefront size={18} />
          <span>Open SenderId</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            // Push vendor id to url.
            PassOnUpdate({ vendorAccountId })

            // Execute handler.
            onAutoRateImport()

            _handleClose()
          }}
          sx={{
            gap: '12px',
            display: 'flex',
            pl: '20px',
            pr: '20px',
            color: 'gray.500',
            minHeight: '40px'
          }}>
          <MdAlternateEmail size={18} />
          <span>Auto Rate Import</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            // Push vendor id to url.
            PassOnUpdate({ vendorAccountId })

            // Execute handler.
            onVendorAccountDelete()

            _handleClose()
          }}
          sx={{
            gap: '12px',
            display: 'flex',
            pl: '20px',
            pr: '20px',
            color: 'gray.500',
            minHeight: '40px'
          }}>
          <HiTrash />
          <span>Delete Vendor Account</span>
        </MenuItem>
      </Menu>
    </>
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {
  'vendorAccountId': PropTypes.string,
  'onVendorAccountUpdate': PropTypes.func,
  'onVendorAccountDelete': PropTypes.func,
  'onAddSenderID': PropTypes.func,
  'PassOnUpdate': PropTypes.func,
  'onContentTranslation': PropTypes.func,
  'contentTranslationId': PropTypes.string,
  'onAutoRateImport': PropTypes.func,
  'smppId': PropTypes.string
}


/*
 * REDUX
 */
const _MapDispatchToProps = __dispatch => ({
  'PassOnUpdate': u => __dispatch({ 'type': 'PASS_ON_UPDATE', 'PassOn': u })
})


/*
 * EXPORT
 */
export default connect(void 0, _MapDispatchToProps)(Index)
